<template>
  <vs-row>
    <vs-col
      vs-w="12"
      class="mt-4"
    >
      <fb-paginacion
        :total="pagination.pages"
        :max="10"
        v-model="page"
      />
    </vs-col>
  </vs-row>
</template>
<script>

import { mapGetters } from 'vuex';

import FbPaginacion from '@/febos/chile/_vue/componentes/FbPaginacion';

export default {
  name: 'MaterialPagination',
  props: {
    value: {
      type: Number,
      required: false,
      default: 1
    }
  },
  components: { FbPaginacion },
  computed: {
    ...mapGetters('Materials', [
      'pagination'
    ]),
    page: {
      get() {
        return this.value;
      },
      set(modifiedValue) {
        this.$emit('input', modifiedValue);
        this.$emit('change', modifiedValue);
      }
    }
  }
};

</script>
